import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { environment } from '../../_environments/environment';
import { CalculatedPrice } from '../../_model/pricing';
import { Allergen, Lifestyle, Nutrient, Recipe } from '../../_model/recipe';
import { Entitytype } from '../../_model/redirect';
import { LifestyleService } from '../../_service/LifestyleService';
import { PricingService } from '../../_service/PricingService';
import { RecipeService } from '../../_service/RecipeService';
import { RedirectService } from '../../_service/RedirectService';
import { CapitalizeFirstPipe } from '../pipe/capitalizefirst.pipe';
import { ChipComponent } from '../chip/chip.component';
import { RouterLink } from '@angular/router';
import { ImageComponent } from '../image/image.component';
import { LowerCasePipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { PersonselectionCompactComponent } from '../personselection/personselection-compact.component';

export enum FeaturedCardStatus {
  PROCESSED = 'PROCESSED',
  SELECTABLE = 'SELECTABLE',
  PERSONEDITABLE = 'PERSONEDITABLE',
  ONBOARD = 'ONBOARD',
  RECIPEFIRST = 'RECIPEFIRST'
}

@Component({
    selector: 'app-featured-card',
    templateUrl: './featured-card.component.html',
    styleUrls: ['./featured-card.component.scss'],
    imports: [
        NgClass, NgTemplateOutlet,
        LowerCasePipe, CapitalizeFirstPipe,
        ImageComponent, ChipComponent, PersonselectionCompactComponent,
        RouterLink, TranslateModule
    ]
})
export class FeaturedCardComponent implements OnInit, AfterViewInit {

  private readonly ALLOWED_LIFESTYLE_IDS = [6, 7, 8, 9]; // Glutenvrij, Vegan, Lactosevrij, Vegetarisch

  environment = environment;
  _recipe: any;
  @Input() set recipe(value: Recipe) {
    this._recipe = value;
    if (this.lifestyles)
      this._recipe.lifestyles = this._recipe.lifestyles.filter(l => this.ALLOWED_LIFESTYLE_IDS.includes(l.lifestyleid) && this.lifestyles.map(s => s.id).includes(l.lifestyleid))
    if (value) {
      this._recipe['recipeurl'] = `/recipe/id/${value.id}`
    }
  }
  @Input() loading: boolean = false;
  @Input() selectedlifestyles: number[] = [];
  @Input() selectedallergens: Allergen[] = [];
  _status: FeaturedCardStatus
  @Input() set status(s: FeaturedCardStatus | string) {
    this._status = FeaturedCardStatus[s]
  }
  @Input() condensed = false;
  @Input() featured = false;
  @Input() colorscheme = 'contrast';

  scheme = {
    light: 'bg-e-white',
    contrast: 'bg-white'
  }

  _selected: boolean
  @Input() set selected(value: boolean) {
    this._selected = value;
    this.loading = false;
  }
  @Output() selectedChange = new EventEmitter<boolean>();

  @Input() persons: number;
  @Output() personsChange = new EventEmitter<number>();

  @Output() showRecipe = new EventEmitter<Recipe>();

  lifestyles: Lifestyle[];
  disablePersonsSelection = true;
  disableShowRecipeAction = true;
  calculatedPrice: CalculatedPrice;

  constructor(
    public _translate: TranslateService,
    public _recipeService: RecipeService,
    public _lifestyleService: LifestyleService,
    private _redirectService: RedirectService,
    private _pricingService: PricingService,
  ) {
  }

  ngOnInit() {
    this._lifestyleService.getLifestyleList().subscribe(result => {
      this.lifestyles = result;
      if (this._recipe)
        this._recipe.lifestyles = this._recipe.lifestyles.filter(l => this.ALLOWED_LIFESTYLE_IDS.includes(l.lifestyleid) && this.lifestyles.map(s => s.id).includes(l.lifestyleid))
    });

    if (this.personsChange.observers.length > 0) {
      this.disablePersonsSelection = false;
    }

    if (this.showRecipe.observers.length > 0) {
      this.disableShowRecipeAction = false;
    }
  }

  ngAfterViewInit() {
    if (!this._recipe) return;
    setTimeout(() => {
      this.getCalculatedPrice(this._recipe);
      this._redirectService.getEntityUrl(Entitytype.RECIPE, this._recipe.id, this._recipe.redirectid).then(value => this._recipe['recipeurl'] = value);
    })
  }

  getCalories(recipe: Recipe) {
    if (!recipe) { return; }
    const calories = recipe.nutrients.find(val => val.name === Nutrient.ENERGY);
    if (calories) {
      return Math.round(calories.quantity);
    } else {
      return null;
    }
  }

  getLifestyle(lifestyleid: number): Lifestyle {
    if (!this.lifestyles) { return null };
    const lifestyle = this.lifestyles.find(val => val.id === lifestyleid);
    if (lifestyle) {
      return lifestyle;
    }
    return null;
  }

  getCalculatedPrice(recipe: Recipe) {
    if (!recipe) return;
    if (!recipe.salessurcharge) { this.calculatedPrice = null; return; }
    this._pricingService.calculateSingleprice(Number(recipe.salessurcharge), false, 1).subscribe(
      result => {
        this.calculatedPrice = result
      }, error => {
        console.log(error);
      }
    )
  }

  overlappingAllergens(): string[] {
    if (!this._recipe || !this._recipe.allergens || !this.selectedallergens) {
      return [];
    }
    return this._recipe.allergens.filter(a => this.selectedallergens.includes(a.name)).map(a => a.name);
  }

  changePersons(personsqty) {
    this.persons = personsqty;
    this.personsChange.emit(this.persons);
  }

  toggleSelection() {
    this.loading = true;
    this.selectedChange.emit(!this._selected);
  }

  showRecipeAction() {
    this.showRecipe.emit(this._recipe);
  }

}
